<div class="list" class="border-{{ border }}">
  <ng-content *ngIf="length"></ng-content>
  <ng-content *ngIf="!length" select="[empty]"></ng-content>
</div>

<div class="pagination-navigation" *ngIf="length">
  <nav aria-label="Page navigation example">
    <ul class="pagination">
      <li
        class="page-item"
        *ngFor="let page of pages"
        [ngClass]="{ active: selectedPage === page }"
      >
        <a class="page-link" (click)="onPageChange(page)">{{ page }}</a>
      </li>
    </ul>
  </nav>
</div>
